var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBootcampJs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 605,
    height: 631,
    viewBox: "0 0 605 631",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M269.162 149.413 121.561 66.216l-.685 76.173 147.669 83.197.617-76.173z",
    fill: "url(#skgscbdr7a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m159.182 105.905 44.404 25.028-.069 9.138-44.403-25.028.068-9.138zM159.044 124.25l94.563 53.259-.068 9.275-94.564-53.26.069-9.274z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.302 108.633c-.069 6.274-3.838 9.275-8.497 6.615-4.66-2.591-8.36-9.82-8.292-16.094.069-6.274 3.838-9.274 8.497-6.615 4.66 2.66 8.36 9.82 8.292 16.094z",
    fill: "#FBBF30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m605 490.656-147.67-83.128-.685 76.173 147.738 83.128.617-76.173z",
    fill: "url(#078nz9o2kb)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m494.95 447.149 44.404 25.027-.069 9.138-44.404-25.027.069-9.138zM494.882 465.493l94.563 53.26-.068 9.274-94.564-53.26.069-9.274z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M487.138 449.945c-.069 6.274-3.838 9.274-8.497 6.615-4.66-2.592-8.36-9.82-8.292-16.094.069-6.274 3.838-9.275 8.497-6.615 4.66 2.591 8.36 9.752 8.292 16.094z",
    fill: "#FBBF30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M432.8 3c-27.821 5.388-90.384 12.344-117.656-3 .205 108.565 26.93 262.616 114.298 389.661 88.739-27.891 117.862-150.504 119.917-257.705C522.087 116.544 460.278 39.553 432.8 3.001z",
    fill: "url(#9pzbhm6a8c)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M398.811 25.505c-27.82 5.387-90.383 12.343-117.656-3 .206 108.496 26.93 262.547 114.299 389.592 88.739-27.891 117.861-150.436 119.917-257.705-27.273-15.412-89.081-92.335-116.56-128.887z",
    fill: "url(#6p5u74iydd)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M515.371 154.392C488.03 138.98 426.29 62.057 398.811 25.505l-3.357 386.592c88.739-27.891 117.861-150.436 119.917-257.705z",
    fill: "url(#p5rpcw6fwe)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m252.306 229.609 136.706 76.992L386.202 631l-136.637-76.991 2.741-324.4z",
    fill: "url(#rh2f0r9jwf)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m268.479 376.84 103.06 58.034-.754 90.152-103.129-58.033.823-90.153z",
    fill: "url(#mwhuyd2s1g)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m271.012 316.83 47.625 26.8-.069 9.274-47.624-26.8.068-9.274zM271.012 335.242l47.625 26.8-.069 9.275-47.624-26.801.068-9.274zM270.671 352.972l90.452 50.941-.068 9.275-90.452-50.941.068-9.275z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m252.306 229.609 136.706 76.992-.411 43.439-136.638-76.991.343-43.44z",
    fill: "url(#vqx3c5o4ch)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M286.294 270.867c-.069 6.546-3.974 9.683-8.771 7.024-4.797-2.728-8.634-10.229-8.566-16.776.069-6.547 3.975-9.684 8.771-7.024 4.797 2.728 8.635 10.229 8.566 16.776z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m332.274 376.704.343-37.37 92.645 52.168-.343 37.371-92.645-52.169z",
    fill: "#FBBF30"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M225.582 218.971 21.654 101.814l.068 105.769 185.975 106.792 18.022 26.527-.137-121.931z",
    fill: "url(#rpayp046vi)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 143.071v-28.71l76.953 44.19v28.71L0 143.071z",
    fill: "#FBBF30"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m173.229 214.607-44.678-25.641v9.274l44.678 25.641v-9.274zM173.229 233.156l-86.136-49.441v9.274l86.136 49.441v-9.274zM173.229 251.772 68.866 191.83v9.274l104.363 59.943v-9.275z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M184.192 230.632c0 8.729 5.208 18.754 11.581 22.436 6.373 3.683 11.581-.409 11.581-9.138s-5.208-18.753-11.581-22.436c-6.373-3.682-11.581.41-11.581 9.138z",
    fill: "#FBBF30"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.003 327.945c4.112 2.319 7.401 8.047 7.401 12.752v20.8l13.842 7.978c4.111 2.319 7.4 8.047 7.4 12.753 0 4.705-3.289 6.614-7.4 4.296l-13.842-7.911v20.8c0 4.705-3.289 6.614-7.401 4.296-4.111-2.319-7.4-8.047-7.4-12.752v-20.8l-13.842-7.91c-4.112-2.319-7.401-8.047-7.401-12.752 0-4.706 3.289-6.615 7.401-4.297l13.842 7.911V332.31c0-4.774 3.289-6.683 7.4-4.365z",
    fill: "url(#kv0lbjkw8j)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "skgscbdr7a",
    x1: 211.52,
    y1: 116.916,
    x2: 178.795,
    y2: 175.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "078nz9o2kb",
    x1: 547.344,
    y1: 458.164,
    x2: 514.618,
    y2: 516.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9pzbhm6a8c",
    x1: 253.433,
    y1: 38.052,
    x2: 443.495,
    y2: 208.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6p5u74iydd",
    x1: 219.451,
    y1: 60.538,
    x2: 409.513,
    y2: 231.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p5rpcw6fwe",
    x1: 525.331,
    y1: 194.38,
    x2: 372.259,
    y2: 223.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rh2f0r9jwf",
    x1: 233.7,
    y1: 345.784,
    x2: 375.613,
    y2: 487.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mwhuyd2s1g",
    x1: 286.717,
    y1: 378.981,
    x2: 346.488,
    y2: 510.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vqx3c5o4ch",
    x1: 298.995,
    y1: 230.042,
    x2: 340.327,
    y2: 346.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rpayp046vi",
    x1: 181.146,
    y1: 176.606,
    x2: 76.245,
    y2: 259.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kv0lbjkw8j",
    x1: 174.312,
    y1: 354.546,
    x2: 138.567,
    y2: 382.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampJs);
export default __webpack_public_path__ + "static/media/Bootcamp-js.a9ed6a3f7b672131f3ba47ff355bba96.svg";
export { ForwardRef as ReactComponent };